module.exports = __webpack_public_path__ + "static/media/27.b071eb43.jpg";